module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA3klEQVQ4T6WToU4DURBFz/0DPqC2FoUhqQAJH0D4giqwtSySWhSyGk8lshV8AoIERWpQ2EuGsJuXZba7WUZO7pyZuW+e+Gcoq7d9CVwDh8AHsAaWkt7b+j8A21fAPbABtsAEOAZ2wEzSVwnJAC8hkHRUC23PgQfgQtJjH8BAJem2FNpO89kE4wC2b347VjFBYm6ZX0l6+1m12DM6D41mxT7AJ3CQTVN7tA/wKmlq+wx4akEGTbCWdG57AdyNAUTNKRDmnowFhPNRPBrQ9SqpB89Jpy5Ac9Lpbxx6DKH7BtUKaBFxfzlsAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/lock.png
// module id = nfP8
// module chunks = 18